module.exports = __webpack_public_path__ + "static/img/articlecrm.0952174.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/articlecrm.jpg
// module id = RJNB
// module chunks = 1